import { render, staticRenderFns } from "./ConfirmationPayment.vue?vue&type=template&id=a4470bbc&"
import script from "./ConfirmationPayment.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports